export default __webpack_public_path__ + "static/media/f11a0677-iphone-walet_10000000ex0tt000004028.1bbb5910.png";